import React from 'react'
import { Loading } from '@guillotinaweb/react-gmi'
import { FileUpload } from '@guillotinaweb/react-gmi'
import { message, Input } from 'antd'

import { I18NField } from '../components/i18nfield'
import { getMediaUrl } from '../consts'

export function BaseField({ label, help, children, ...props }) {
  return (
    <div className="field is-horizontal">
      <div className="field-label is-normal">
        <label className="label">{label}</label>
      </div>
      <div className="field-body">
        <div className="field">
          <div className="control" {...props}>
            {children}
          </div>
          {help && <p class="help">{help}</p>}
        </div>
      </div>
    </div>
  )
}

export function Field({
  label,
  value,
  onChange,
  placeholder,
  readonly = false,
  disabled = false,
  type = 'text',
  className = [],
  help = '',
  ...rest
}) {
  return (
    <BaseField label={label} help={help}>
      <input
        className={['input', ...className].join(' ')}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readonly}
        disabled={disabled}
        {...rest}
      />
    </BaseField>
  )
}

export function ImageEditor({
  Ctx,
  canModifyContent,
  field,
  uploadFieldName,
  label,
  caption,
  alt,
  onChangeCaption,
  onChangeAlt,
  size,
  folder = null,
  style = { width: 300 },
}) {
  const [imgLoading, setImgLoading] = React.useState(false)
  const sizeTxt = size ? ` (${size})` : ''
  const labelTxt = label ? `${label}${sizeTxt}:` : ''

  const uploadFile = async (file) => {
    // @TODO implement some kind of file validation
    setImgLoading(true)

    if (size) {
      const [width, height] = await getImgDimensionsFromArrayBuffer(file)
      if (size.trim() !== `${width}x${height}`) {
        message.error(
          `Image size must be ${size} instead of ${width}x${height}`
        )
        setImgLoading(false)
        return
      }
    }

    const resp = await Ctx.client.upload(
      Ctx.path,
      file,
      folder,
      uploadFieldName
    )
    if (resp.status !== 200) Ctx.flash('error_uploading_file', 'danger')
    else Ctx.refresh()
    setImgLoading(false)
  }

  return (
    <>
      {labelTxt && (
        <div style={{ fontSize: 14, margin: '10px 0' }}>{labelTxt}</div>
      )}
      {field && (
        <figure class="image" style={style}>
          <img src={getMediaUrl() + field} alt="" />
          {canModifyContent && (
            <a
              href="#"
              className="delete is-medium"
              style={{
                position: 'absolute',
                top: 6,
                right: 6,
                backgroundColor: '#FF0000AA',
              }}
              onClick={async () => {
                const resp = await Ctx.client.deleteFile(
                  Ctx.path,
                  uploadFieldName
                )
                if (resp.status !== 200) {
                  Ctx.flash('error_deleting_file', 'danger')
                } else {
                  Ctx.flash('Imagen borrada', 'success')
                  Ctx.refresh()
                }
              }}
            ></a>
          )}
        </figure>
      )}
      {canModifyContent &&
        (!imgLoading ? (
          <FileUpload onChange={uploadFile} accept="image/*" />
        ) : (
          <Loading />
        ))}
      {(caption || alt) && (
        <I18NField Widget={() => null}>
          {(lang) => (
            <React.Fragment key={`${uploadFieldName}_alt_caption${lang}`}>
              {alt && (
                <Input
                  defaultValue={alt[lang]}
                  onChange={(e) =>
                    onChangeAlt?.({ ...alt, [lang]: e.target.value })
                  }
                  prefix={
                    <span style={{ fontSize: 12, color: 'grey', width: 80 }}>
                      Alt / title
                    </span>
                  }
                />
              )}
              {caption && (
                <Input
                  defaultValue={caption[lang]}
                  onChange={(e) =>
                    onChangeCaption?.({ ...caption, [lang]: e.target.value })
                  }
                  prefix={
                    <span style={{ fontSize: 12, color: 'grey', width: 80 }}>
                      Caption
                    </span>
                  }
                />
              )}
            </React.Fragment>
          )}
        </I18NField>
      )}
    </>
  )
}

function getImgDimensionsFromArrayBuffer(file) {
  return new Promise((res) => {
    const fr = new FileReader()

    fr.onload = () => {
      const img = new Image()

      img.onload = () => {
        res([img.width, img.height])
      }

      img.src = fr.result
    }

    fr.readAsDataURL(new Blob([file.data]))
  })
}
